/**
 * 1 "Administrador"
 * 2 "Super user"
 * 3 "Executive OPS / OKAM"
 * 4 "Executive sales"
 * 5 "Cliente ejecutivo de compras"
 * 6 "Cliente"
 * 7 "Custom Agent"
 */

export const moduleActions = {
  PEDIDO_ALTA: "PEDIDO_ALTA",
  PEDIDO_ELIMINAR: "PEDIDO_ELIMINAR",
  PEDIDO_DUPLICAR: "PEDIDO_DUPLICAR",
  PEDIDO_CANCELAR: "PEDIDO_CANCELAR",
  PEDIDO_EDITAR: "PEDIDO_EDITAR",
  PEDIDO_ELIMINAR_DOCUMENTO: "PEDIDO_ELIMINAR_DOCUMENTO",
  PEDIDO_ACCIONES: "PEDIDO_ACCIONES",
  COMENTARIO: "COMENTARIO",

  PLAN_TRANSPORTE_ALTA: "PLAN_TRANSPORTE_ALTA",
  PLAN_TRANSPORTE_EDITAR: "PLAN_TRANSPORTE_EDITAR",
  PLAN_TRANSPORTE_REENVIARPT: "PLAN_TRANSPORTE_REENVIARPT",
  PLAN_TRANSPORTE_VISUALIZAR_LIST: "PLAN_TRANSPORTE_VISUALIZAR_LIST",
  PLAN_TRANSPORTE_VISUALIZAR_DET: "PLAN_TRANSPORTE_VISUALIZAR_DET",

  PO_VISIBILITY_CREATE: "PO_VISIBILITY_CREATE",

  PO_MANAGEMENT_EDIT: "PO_MANAGEMENT_EDIT",
  PO_MANAGEMENT_VIEW_LIST: "PO_MANAGEMENT_VIEW_LIST",
  PO_MANAGEMENT_VIEW_DETAIL: "PO_MANAGEMENT_VIEW_DETAIL",
  PO_MANAGEMENT_VIEW_DOCUMENTS: "PO_MANAGEMENT_VIEW_DOCUMENTS",
  PO_MANAGEMENT_UPLOAD_DOCUMENTS: "PO_MANAGEMENT_UPLOAD_DOCUMENTS",
  PO_MANAGEMENT_DOWNLOAD_DOCUMENTS: "PO_MANAGEMENT_DOWNLOAD_DOCUMENTS",
  PO_MANAGEMENT_DELETE_DOCUMENTS: "PO_MANAGEMENT_DELETE_DOCUMENTS",
  PO_MANAGEMENT_EDIT_ITEM: "PO_MANAGEMENT_EDIT_ITEM",
  PO_MANAGEMENT_ACCEPT_ITEM: "PO_MANAGEMENT_ACCEPT_ITEM",
  PO_MANAGEMENT_DECLINE_ITEM: "PO_MANAGEMENT_DECLINE_ITEM",
  PO_MANAGEMENT_CANCEL_ITEM: "PO_MANAGEMENT_CANCEL_ITEM",
  PO_MANAGEMENT_PARCED_ITEM: "PO_MANAGEMENT_PARCED_ITEM",
  PO_MANAGEMENT_MASSIVE_UPDATE: "PO_MANAGEMENT_MASSIVE_UPDATE",
  PO_MANAGEMENT_LOAD_PO: "PO_MANAGEMENT_LOAD_PO",
  // PO_MANAGEMENT_CONFIRM_ITEMS: "PO_MANAGEMENT_CONFIRM_ITEMS",

  ASSOCIATION_OF_ENTITIES_LIST: "ASSOCIATION_OF_ENTITIES_LIST",
  ASSOCIATION_OF_ENTITIES_ASSOCIATE: "ASSOCIATION_OF_ENTITIES_ASSOCIATE",

  ADMIN_VISUALIZAR: "ADMIN_VISUALIZAR",
  ADMIN_USUARIO_ALTA: "ADMIN_USUARIO_ALTA",
  ADMIN_USUARIO_EDITAR: "ADMIN_USUARIO_EDITAR",

  SHIPMENT_DETALLE: "SHIPMENT_DETALLE",
  SHIPMENT_DELETE_DOCUMENT: "SHIPMENT_DELETE_DOCUMENT",
  SHIPMENT_DOWNLOAD_DOCUMENT: "SHIPMENT_DOWNLOAD_DOCUMENT",
  SHIPMENT_VIEW_DOCUMENT: "SHIPMENT_VIEW_DOCUMENT",
  SHIPMENT_DETAIL_DLEETE_SHIPMENT: "SHIPMENT_DETAIL_DLEETE_SHIPMENT",
  PEDIDO_DETALLE: "PEDIDO_DETALLE",
  PO_DETALLE: "PO_DETALLE",

  MI_PERFIL_USER_LIST: "MI_PERFIL_USER_LIST",
  MI_PERFIL_USER_EDIT: "MI_PERFIL_USER_EDIT",
  MI_PERFIL_DOCUMENTS_LIST_COMPANY: "MI_PERFIL_DOCUMENTS_LIST_COMPANY",

  ADMIN_ALERTA_EDITAR: "ADMIN_ALERTA_EDITAR",
  ADMIN_ALERTA_LIST: "ADMIN_ALERTA_EDITAR",

  TIME_SENSITIVE: "TIME_SENSITIVE",

  FINANCE_MODULE: "FINANCE_MODULE",
  FINANCE_MODULE_CREDIT_LINE_GRAPHIC: "FINANCE_MODULE_CREDIT_LINE_GRAPHIC",

  ANALYTICS_MODULE: "ANALYTICS_MODULE",

  MY_REPORTS_MODULE: "MY_REPORTS_MODULE",
  MY_REPORTS_CREATION: "MY_REPORTS_CREATION",

  LOGISTICS_TOOLS_MODULE: "LOGISTICS_TOOLS_MODULE",

  SERVICE_DESK_LIST: "SERVICE_DESK_LIST",
  DELETE_COMMENTS: "DELETE_COMMENTS",
  DELETE_DOCUMENTS: "DELETE_DOCUMENTS",

  SUPPLIER_MANAGEMENT_EDIT: 'SUPPLIER_MANAGEMENT_EDIT',
  SUPPLIER_MANAGEMENT_EDIT_ITEM: "SUPPLIER_MANAGEMENT_EDIT_ITEM",
  SUPPLIER_MANAGEMENT_MASSIVE_UPDATE: "SUPPLIER_MANAGEMENT_MASSIVE_UPDATE"
};

export const roleModuleFilter = [
  {
    Rol: 1,
    Full: true,
    Actions: [],
  },
  {
    Rol: 2,
    Full: true,
    Actions: [],
  },
  {
    Rol: 3,
    Filters: [
      moduleActions.PEDIDO_ELIMINAR,
      moduleActions.PEDIDO_DUPLICAR,
      moduleActions.PEDIDO_CANCELAR,
      moduleActions.PEDIDO_EDITAR,
      moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
      moduleActions.PLAN_TRANSPORTE_EDITAR,
      moduleActions.PLAN_TRANSPORTE_REENVIARPT,
      moduleActions.COMENTARIO,
      moduleActions.ASSOCIATION_OF_ENTITIES_LIST,
      moduleActions.PO_VISIBILITY_CREATE,
      moduleActions.PO_MANAGEMENT_EDIT,
      moduleActions.PO_MANAGEMENT_VIEW_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_DETAIL,
      moduleActions.PO_MANAGEMENT_UPLOAD_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_VIEW_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_DOWNLOAD_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_DELETE_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_EDIT_ITEM,
      moduleActions.PO_MANAGEMENT_ACCEPT_ITEM,
      moduleActions.PO_MANAGEMENT_DECLINE_ITEM,
      moduleActions.PO_MANAGEMENT_CANCEL_ITEM,
      moduleActions.PO_MANAGEMENT_PARCED_ITEM,
      moduleActions.PO_MANAGEMENT_MASSIVE_UPDATE,
      moduleActions.ASSOCIATION_OF_ENTITIES_ASSOCIATE,
      moduleActions.TIME_SENSITIVE,
      moduleActions.FINANCE_MODULE,
      moduleActions.ANALYTICS_MODULE,
      moduleActions.MY_REPORTS_MODULE,
      moduleActions.MY_REPORTS_CREATION,
      moduleActions.LOGISTICS_TOOLS_MODULE,
      moduleActions.SUPPLIER_MANAGEMENT_EDIT_ITEM,
      moduleActions.DELETE_COMMENTS,
      moduleActions.DELETE_DOCUMENTS
    ],
    SkipUserCheck: [
      moduleActions.DELETE_DOCUMENTS
    ],
  },
  {
    Rol: 4,
    Filters: [
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
      moduleActions.COMENTARIO,
      moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,
      moduleActions.ASSOCIATION_OF_ENTITIES_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_DETAIL,
      moduleActions.PO_MANAGEMENT_UPLOAD_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_VIEW_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_DOWNLOAD_DOCUMENTS,
      moduleActions.ASSOCIATION_OF_ENTITIES_ASSOCIATE,
      moduleActions.TIME_SENSITIVE,
      moduleActions.FINANCE_MODULE,
      moduleActions.ANALYTICS_MODULE,
      moduleActions.MY_REPORTS_MODULE,
      moduleActions.MY_REPORTS_CREATION,
      moduleActions.LOGISTICS_TOOLS_MODULE,
      moduleActions.DELETE_COMMENTS,
      moduleActions.DELETE_DOCUMENTS
    ],
  },
  {
    Rol: 5,
    Filters: [
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
      moduleActions.COMENTARIO,
      moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,
      moduleActions.ASSOCIATION_OF_ENTITIES_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_DETAIL,
      moduleActions.PO_MANAGEMENT_UPLOAD_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_VIEW_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_DOWNLOAD_DOCUMENTS,
      moduleActions.TIME_SENSITIVE,
      moduleActions.FINANCE_MODULE,
      moduleActions.ANALYTICS_MODULE,
      moduleActions.MY_REPORTS_MODULE,
      moduleActions.MY_REPORTS_CREATION,
      moduleActions.LOGISTICS_TOOLS_MODULE,
      moduleActions.PO_MANAGEMENT_EDIT,
      moduleActions.DELETE_COMMENTS,
      moduleActions.DELETE_DOCUMENTS
    ],
  },
  {
    Rol: 6,
    Filters: [
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
      moduleActions.COMENTARIO,
      moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,
      moduleActions.ASSOCIATION_OF_ENTITIES_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_DETAIL,
      moduleActions.PO_MANAGEMENT_UPLOAD_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_VIEW_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_DOWNLOAD_DOCUMENTS,
      moduleActions.TIME_SENSITIVE,
      moduleActions.FINANCE_MODULE,
      moduleActions.ANALYTICS_MODULE,
      moduleActions.MY_REPORTS_MODULE,
      moduleActions.MY_REPORTS_CREATION,
      moduleActions.LOGISTICS_TOOLS_MODULE,
      moduleActions.PO_MANAGEMENT_EDIT,
      moduleActions.DELETE_COMMENTS,
      moduleActions.DELETE_DOCUMENTS
    ],
  },
  {
    Rol: 7,
    Filters: [
      moduleActions.PO_MANAGEMENT_VIEW_LIST,
      moduleActions.SHIPMENT_DELETE_DOCUMENT,
      moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,
      moduleActions.PO_MANAGEMENT_EDIT,
      moduleActions.DELETE_COMMENTS,
      moduleActions.DELETE_DOCUMENTS
    ],
  },
  {
    Rol: 8,
    Filters: [
      moduleActions.SUPPLIER_MANAGEMENT_EDIT,
      moduleActions.SUPPLIER_MANAGEMENT_EDIT_ITEM,
      moduleActions.SUPPLIER_MANAGEMENT_MASSIVE_UPDATE,
      moduleActions.DELETE_COMMENTS,
      moduleActions.DELETE_DOCUMENTS
    ],
  }, {
    Rol: 9,
    Filters: [
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
      moduleActions.COMENTARIO,
      moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,
      moduleActions.ASSOCIATION_OF_ENTITIES_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_DETAIL,
      moduleActions.PO_MANAGEMENT_UPLOAD_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_VIEW_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_DOWNLOAD_DOCUMENTS,
      moduleActions.TIME_SENSITIVE,
      moduleActions.FINANCE_MODULE,
      moduleActions.ANALYTICS_MODULE,
      moduleActions.MY_REPORTS_MODULE,
      moduleActions.MY_REPORTS_CREATION,
      moduleActions.LOGISTICS_TOOLS_MODULE,
      moduleActions.PO_MANAGEMENT_EDIT,
      moduleActions.SUPPLIER_MANAGEMENT_EDIT,
      moduleActions.SUPPLIER_MANAGEMENT_EDIT_ITEM,
      moduleActions.SUPPLIER_MANAGEMENT_MASSIVE_UPDATE,
      moduleActions.DELETE_COMMENTS,
      moduleActions.DELETE_DOCUMENTS
    ],
  },
];

export const roleCustomerFilter = [
  {
    Rol: 1,
    Full: true,
    Actions: [],
  },
  {
    Rol: 2,
    Full: true,
    Actions: [],
  },
  {
    Rol: 3,
    Filters: [
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
      moduleActions.SHIPMENT_DETALLE,
      moduleActions.PEDIDO_DETALLE,
      moduleActions.PO_DETALLE,
      moduleActions.PO_VISIBILITY_CREATE,
      moduleActions.ASSOCIATION_OF_ENTITIES_LIST,
      moduleActions.PO_MANAGEMENT_EDIT,
      moduleActions.PO_MANAGEMENT_VIEW_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_DETAIL,
      moduleActions.PO_MANAGEMENT_UPLOAD_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_VIEW_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_DOWNLOAD_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_DELETE_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_EDIT_ITEM,
      moduleActions.PO_MANAGEMENT_ACCEPT_ITEM,
      moduleActions.PO_MANAGEMENT_DECLINE_ITEM,
      moduleActions.PO_MANAGEMENT_CANCEL_ITEM,
      moduleActions.PO_MANAGEMENT_PARCED_ITEM,
      moduleActions.PO_MANAGEMENT_MASSIVE_UPDATE,
      moduleActions.ASSOCIATION_OF_ENTITIES_ASSOCIATE,
      moduleActions.TIME_SENSITIVE,
      moduleActions.FINANCE_MODULE,
      moduleActions.ANALYTICS_MODULE,
      moduleActions.MY_REPORTS_MODULE,
      moduleActions.MY_REPORTS_CREATION,
      moduleActions.LOGISTICS_TOOLS_MODULE,
      moduleActions.SUPPLIER_MANAGEMENT_EDIT_ITEM
    ],
  },
  {
    Rol: 4,
    Filters: [
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
      moduleActions.SHIPMENT_DETALLE,
      moduleActions.PEDIDO_DETALLE,
      moduleActions.PO_DETALLE,
      moduleActions.ASSOCIATION_OF_ENTITIES_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_DETAIL,
      moduleActions.PO_MANAGEMENT_UPLOAD_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_VIEW_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_DOWNLOAD_DOCUMENTS,
      moduleActions.ASSOCIATION_OF_ENTITIES_ASSOCIATE,
      moduleActions.TIME_SENSITIVE,
      moduleActions.FINANCE_MODULE,
      moduleActions.ANALYTICS_MODULE,
      moduleActions.MY_REPORTS_MODULE,
      moduleActions.MY_REPORTS_CREATION,
      moduleActions.LOGISTICS_TOOLS_MODULE
    ],
  },
  {
    Rol: 5,
    Filters: [
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
      moduleActions.SHIPMENT_DETALLE,
      moduleActions.PEDIDO_DETALLE,
      moduleActions.PO_DETALLE,
      moduleActions.ASSOCIATION_OF_ENTITIES_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_DETAIL,
      moduleActions.PO_MANAGEMENT_UPLOAD_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_VIEW_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_DOWNLOAD_DOCUMENTS,
      moduleActions.TIME_SENSITIVE,
      moduleActions.FINANCE_MODULE,
      moduleActions.ANALYTICS_MODULE,
      moduleActions.MY_REPORTS_MODULE,
      moduleActions.MY_REPORTS_CREATION,
      moduleActions.LOGISTICS_TOOLS_MODULE,
      moduleActions.PO_MANAGEMENT_EDIT
    ],
  },
  {
    Rol: 6,
    Filters: [
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
      moduleActions.SHIPMENT_DETALLE,
      moduleActions.PEDIDO_DETALLE,
      moduleActions.PO_DETALLE,
      moduleActions.ASSOCIATION_OF_ENTITIES_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_DETAIL,
      moduleActions.PO_MANAGEMENT_UPLOAD_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_VIEW_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_DOWNLOAD_DOCUMENTS,
      moduleActions.TIME_SENSITIVE,
      moduleActions.FINANCE_MODULE,
      moduleActions.ANALYTICS_MODULE,
      moduleActions.MY_REPORTS_MODULE,
      moduleActions.MY_REPORTS_CREATION,
      moduleActions.LOGISTICS_TOOLS_MODULE,
      moduleActions.PO_MANAGEMENT_EDIT
    ],
  },
  {
    Rol: 7,
    Filters: [
      moduleActions.PO_MANAGEMENT_VIEW_LIST,
      moduleActions.SHIPMENT_DELETE_DOCUMENT,
      moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,
      moduleActions.PO_MANAGEMENT_EDIT
    ],
  },
  {
    Rol: 8,
    Filters: [
      moduleActions.SUPPLIER_MANAGEMENT_EDIT
    ],
  },
  {
    Rol: 9,
    Filters: [
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
      moduleActions.SHIPMENT_DETALLE,
      moduleActions.PEDIDO_DETALLE,
      moduleActions.PO_DETALLE,
      moduleActions.ASSOCIATION_OF_ENTITIES_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_LIST,
      moduleActions.PO_MANAGEMENT_VIEW_DETAIL,
      moduleActions.PO_MANAGEMENT_UPLOAD_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_VIEW_DOCUMENTS,
      moduleActions.PO_MANAGEMENT_DOWNLOAD_DOCUMENTS,
      moduleActions.TIME_SENSITIVE,
      moduleActions.FINANCE_MODULE,
      moduleActions.ANALYTICS_MODULE,
      moduleActions.MY_REPORTS_MODULE,
      moduleActions.MY_REPORTS_CREATION,
      moduleActions.LOGISTICS_TOOLS_MODULE,
      moduleActions.PO_MANAGEMENT_EDIT,
      moduleActions.SUPPLIER_MANAGEMENT_EDIT
    ],
  },
];


export const ROLES = {
  ADMIN: 1,
  SUPER_USER: 2,
  EXECUTIVE_OPS_OKAM: 3,
  EXECUTIVE_SALES: 4,
  CUSTOMER_MANAGER: 5,
  CUSTOMER: 6,
  CUSTOMS_AGENT: 7,
  SUPPLIER_MANAGEMENT: 8,
  CUSTOMER_SUPPLIER_MANAGEMENT: 9
};

// export const PERMISSIONS = {
//   PO_MANAGEMENT_VIEW_LIST: "PO_MANAGEMENT_VIEW_LIST",
//   PO_MANAGEMENT_LOAD_PO: "PO_MANAGEMENT_LOAD_PO",
//   PO_VISIBILITY_CREATE: "PO_VISIBILITY_CREATE",
//   PLAN_TRANSPORTE_VISUALIZAR_LIST: "PLAN_TRANSPORTE_VISUALIZAR_LIST",
//   ADMIN_VISUALIZAR: "ADMIN_VISUALIZAR",
//   ASSOCIATION_OF_ENTITIES_LIST: "ASSOCIATION_OF_ENTITIES_LIST",
//   ADMIN_ALERTA_LIST: "ADMIN_ALERTA_LIST",
//   LOGISTICS_TOOLS_MODULE: "LOGISTICS_TOOLS_MODULE",
//   MY_REPORTS_MODULE: "MY_REPORTS_MODULE",
//   MY_REPORTS_CREATION: "MY_REPORTS_CREATION",
//   PLAN_TRANSPORTE_ALTA: "PLAN_TRANSPORTE_ALTA",
//   ANALYTICS_MODULE: "ANALYTICS_MODULE",
//   FINANCE_MODULE: "FINANCE_MODULE",
//   TIME_SENSITIVE: "TIME_SENSITIVE",
//   PLAN_TRANSPORTE_VISUALIZAR_DET: "PLAN_TRANSPORTE_VISUALIZAR_DET",
//   ADMIN_USUARIO_ALTA: "ADMIN_USUARIO_ALTA",
//   ADMIN_USUARIO_EDITAR: "ADMIN_USUARIO_EDITAR",
//   ADMIN_ALERTA_EDITAR: "ADMIN_ALERTA_EDITAR",
//   SERVICE_DESK_LIST: "SERVICE_DESK_LIST",
//   SUPPLIER_MANAGEMENT: "SUPPLIER_MANAGEMENT",
//   SUPPLIER_MANAGEMENT_DETAIL: "SUPPLIER_MANAGEMENT_DETAIL",
//   QUICK_SEARCH: "QUICK_SEARCH",
//   DASHBOARD: 'DASHBOARD',
//   PO_VISIBILITY: 'PO_VISIBILITY',
//   PO_VISIBILITY_DETAIL: 'PO_VISIBILITY_DETAIL',
//   SHIPMENTS: 'SHIPMENTS',
//   SHIPMENT_DETAIL: 'SHIPMENT_DETAIL',
//   MY_PROFILE: "MY_PROFILE",
// };

export const PERMISSIONS = {
  DASHBOARD: 'DASHBOARD',
  PO_VISIBILITY: 'PO_VISIBILITY',
  PO_MANAGEMENT: "PO_MANAGEMENT",
  LOAD_PO: "LOAD_PO",
  LOAD_PO_IA: "LOAD_PO_IA",
  SUPPLIER_MANAGEMENT: "SUPPLIER_MANAGEMENT",
  ENTITY_ASSOCIATION: "ENTITY_ASSOCIATION",
  TRANSPORT_PLANS: "TRANSPORT_PLANS",
  SHIPMENTS: 'SHIPMENTS',
  FINANCE: "FINANCE",
  TIME_SENSITIVE: "TIME_SENSITIVE",
  ANALYTICS: "ANALYTICS",
  MY_REPORTS: "MY_REPORTS",
  LOGISTICS_TOOLS: "LOGISTICS_TOOLS",
  MY_PROFILE: "MY_PROFILE",
  ADMIN: "ADMIN",
  SERVICE_DESK: "SERVICE_DESK",

  QUICK_SEARCH: "QUICK_SEARCH",
};

export const PERMISSION_TO_MODULE_ID = {
  [PERMISSIONS.DASHBOARD]: "15",
  [PERMISSIONS.PO_VISIBILITY]: "2",
  [PERMISSIONS.PO_MANAGEMENT]: "10",
  [PERMISSIONS.SUPPLIER_MANAGEMENT]: "13",
  [PERMISSIONS.ENTITY_ASSOCIATION]: "14",
  [PERMISSIONS.TRANSPORT_PLANS]: "1",
  [PERMISSIONS.SHIPMENTS]: "3",
  [PERMISSIONS.FINANCE]: "6",
  [PERMISSIONS.TIME_SENSITIVE]: "12",
  [PERMISSIONS.ANALYTICS]: "7",
  [PERMISSIONS.MY_REPORTS]: "9",
  [PERMISSIONS.LOGISTICS_TOOLS]: "16",
  [PERMISSIONS.MY_PROFILE]: "8",
  [PERMISSIONS.ADMIN]: "17",
  [PERMISSIONS.SERVICE_DESK]: "18",
};

export const roleModuleAction = [
  {
    Rol: ROLES.ADMIN,
    Name: "Administrador",
    Full: true
  },
  {
    Rol: ROLES.SUPER_USER,
    Name: "Super user",
    Actions: [
      PERMISSIONS.DASHBOARD,
      PERMISSIONS.PO_VISIBILITY,
      PERMISSIONS.PO_MANAGEMENT,
      PERMISSIONS.ENTITY_ASSOCIATION,
      PERMISSIONS.TRANSPORT_PLANS,
      PERMISSIONS.SHIPMENTS,
      PERMISSIONS.TIME_SENSITIVE,
      PERMISSIONS.ANALYTICS,
      PERMISSIONS.MY_REPORTS,
      PERMISSIONS.LOGISTICS_TOOLS,
      PERMISSIONS.MY_PROFILE,
      PERMISSIONS.QUICK_SEARCH,
      PERMISSIONS.FINANCE,
      PERMISSIONS.LOAD_PO,
      PERMISSIONS.LOAD_PO_IA,

      moduleActions.PEDIDO_ALTA,
      moduleActions.PEDIDO_ELIMINAR,
      moduleActions.PEDIDO_DUPLICAR,
      moduleActions.PEDIDO_CANCELAR,
      moduleActions.PEDIDO_ACCIONES,
      moduleActions.PEDIDO_EDITAR,
      moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,

      moduleActions.PLAN_TRANSPORTE_EDITAR,

      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
      moduleActions.PLAN_TRANSPORTE_ALTA,
      moduleActions.PO_VISIBILITY_CREATE,
      moduleActions.PO_MANAGEMENT_EDIT,
      moduleActions.PO_MANAGEMENT_VIEW_LIST,
      moduleActions.PO_MANAGEMENT_EDIT_ITEM,
      moduleActions.PO_MANAGEMENT_ACCEPT_ITEM,
      moduleActions.PO_MANAGEMENT_DECLINE_ITEM,
      moduleActions.PO_MANAGEMENT_CANCEL_ITEM,
      moduleActions.PO_MANAGEMENT_PARCED_ITEM,
      moduleActions.PO_MANAGEMENT_MASSIVE_UPDATE,
      moduleActions.ASSOCIATION_OF_ENTITIES_ASSOCIATE,
      moduleActions.TIME_SENSITIVE,
      moduleActions.ANALYTICS_MODULE,
      moduleActions.MY_REPORTS_MODULE,
      moduleActions.MY_REPORTS_CREATION,
      moduleActions.LOGISTICS_TOOLS_MODULE,
      moduleActions.SHIPMENT_VIEW_DOCUMENT,
      moduleActions.MI_PERFIL_DOCUMENTS_LIST_COMPANY,
    ],
  },
  {
    Rol: ROLES.EXECUTIVE_OPS_OKAM,
    Name: "Executive OPS / OKAM",
    Actions: [
      PERMISSIONS.DASHBOARD,
      PERMISSIONS.PO_VISIBILITY,
      PERMISSIONS.PO_MANAGEMENT,
      PERMISSIONS.ENTITY_ASSOCIATION,
      PERMISSIONS.TRANSPORT_PLANS,
      PERMISSIONS.SHIPMENTS,
      PERMISSIONS.TIME_SENSITIVE,
      PERMISSIONS.ANALYTICS,
      PERMISSIONS.MY_REPORTS,
      PERMISSIONS.LOGISTICS_TOOLS,
      PERMISSIONS.MY_PROFILE,
      PERMISSIONS.FINANCE,
      PERMISSIONS.LOAD_PO,
      PERMISSIONS.LOAD_PO_IA,

      PERMISSIONS.QUICK_SEARCH,

      moduleActions.PEDIDO_ALTA,
      moduleActions.PEDIDO_ELIMINAR,
      moduleActions.PEDIDO_DUPLICAR,
      moduleActions.PEDIDO_CANCELAR,
      moduleActions.PEDIDO_ACCIONES,
      moduleActions.PEDIDO_EDITAR,
      moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,
      moduleActions.PLAN_TRANSPORTE_EDITAR,

      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
      moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
      moduleActions.PLAN_TRANSPORTE_ALTA,
      moduleActions.PO_VISIBILITY_CREATE,
      moduleActions.PO_MANAGEMENT_EDIT,
      moduleActions.PO_MANAGEMENT_VIEW_LIST,
      moduleActions.PO_MANAGEMENT_EDIT_ITEM,
      moduleActions.PO_MANAGEMENT_ACCEPT_ITEM,
      moduleActions.PO_MANAGEMENT_DECLINE_ITEM,
      moduleActions.PO_MANAGEMENT_CANCEL_ITEM,
      moduleActions.PO_MANAGEMENT_PARCED_ITEM,
      moduleActions.PO_MANAGEMENT_MASSIVE_UPDATE,
      moduleActions.ASSOCIATION_OF_ENTITIES_ASSOCIATE,
      moduleActions.TIME_SENSITIVE,
      moduleActions.ANALYTICS_MODULE,
      moduleActions.MY_REPORTS_MODULE,
      moduleActions.MY_REPORTS_CREATION,
      moduleActions.LOGISTICS_TOOLS_MODULE,
      moduleActions.SHIPMENT_VIEW_DOCUMENT,
      moduleActions.DELETE_DOCUMENTS,
      moduleActions.MI_PERFIL_DOCUMENTS_LIST_COMPANY,
    ],
  },
  {
    Rol: ROLES.EXECUTIVE_SALES,
    Name: "Executive sales",
    Actions: [
      PERMISSIONS.DASHBOARD,
      PERMISSIONS.PO_VISIBILITY,
      PERMISSIONS.PO_MANAGEMENT,
      PERMISSIONS.ENTITY_ASSOCIATION,
      PERMISSIONS.TRANSPORT_PLANS,
      PERMISSIONS.SHIPMENTS,
      PERMISSIONS.TIME_SENSITIVE,
      PERMISSIONS.ANALYTICS,
      PERMISSIONS.MY_REPORTS,
      PERMISSIONS.LOGISTICS_TOOLS,
      PERMISSIONS.MY_PROFILE,
      PERMISSIONS.FINANCE,

      PERMISSIONS.QUICK_SEARCH,

      moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,
      moduleActions.SHIPMENT_DETALLE,
      moduleActions.PEDIDO_DETALLE,
      moduleActions.ASSOCIATION_OF_ENTITIES_ASSOCIATE,
      moduleActions.SHIPMENT_VIEW_DOCUMENT,
      moduleActions.MI_PERFIL_DOCUMENTS_LIST_COMPANY,
    ],
  },
  {
    Rol: ROLES.CUSTOMER_MANAGER,
    Name: "Manager (Customer)",
    Actions: [
      PERMISSIONS.DASHBOARD,
      PERMISSIONS.PO_VISIBILITY,
      PERMISSIONS.PO_MANAGEMENT,
      PERMISSIONS.TRANSPORT_PLANS,
      PERMISSIONS.SHIPMENTS,
      PERMISSIONS.FINANCE,
      PERMISSIONS.TIME_SENSITIVE,
      PERMISSIONS.ANALYTICS,
      PERMISSIONS.MY_REPORTS,
      PERMISSIONS.LOGISTICS_TOOLS,
      PERMISSIONS.MY_PROFILE,
      PERMISSIONS.FINANCE,
      PERMISSIONS.LOAD_PO,

      PERMISSIONS.QUICK_SEARCH,

      moduleActions.SHIPMENT_DETALLE,
      moduleActions.PEDIDO_DETALLE,
      moduleActions.PO_MANAGEMENT_EDIT,
      moduleActions.SHIPMENT_VIEW_DOCUMENT,
      moduleActions.MI_PERFIL_DOCUMENTS_LIST_COMPANY,
    ],
  },
  {
    Rol: ROLES.CUSTOMER,
    Name: "Customer",
    Actions: [
      PERMISSIONS.DASHBOARD,
      PERMISSIONS.PO_VISIBILITY,
      PERMISSIONS.PO_MANAGEMENT,
      PERMISSIONS.TRANSPORT_PLANS,
      PERMISSIONS.SHIPMENTS,
      PERMISSIONS.FINANCE,
      PERMISSIONS.TIME_SENSITIVE,
      PERMISSIONS.ANALYTICS,
      PERMISSIONS.MY_REPORTS,
      PERMISSIONS.LOGISTICS_TOOLS,
      PERMISSIONS.MY_PROFILE,
      PERMISSIONS.LOAD_PO,

      PERMISSIONS.QUICK_SEARCH,


      moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,
      moduleActions.SHIPMENT_DETALLE,
      moduleActions.PEDIDO_DETALLE,
      moduleActions.SHIPMENT_VIEW_DOCUMENT,
      moduleActions.MI_PERFIL_DOCUMENTS_LIST_COMPANY,
    ],
  },
  {
    Rol: ROLES.CUSTOMS_AGENT,
    Name: "Customs Agent",
    Actions: [
      PERMISSIONS.DASHBOARD,
      PERMISSIONS.PO_VISIBILITY,
      PERMISSIONS.PO_MANAGEMENT,
      PERMISSIONS.TRANSPORT_PLANS,
      PERMISSIONS.SHIPMENTS,
      PERMISSIONS.FINANCE,
      PERMISSIONS.TIME_SENSITIVE,
      PERMISSIONS.ANALYTICS,
      PERMISSIONS.MY_PROFILE,

      PERMISSIONS.QUICK_SEARCH,


      moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,
      moduleActions.SHIPMENT_DELETE_DOCUMENT,
      moduleActions.SHIPMENT_DOWNLOAD_DOCUMENT,
      moduleActions.PO_MANAGEMENT_EDIT,
      moduleActions.SHIPMENT_VIEW_DOCUMENT
    ],
  },
  {
    Rol: ROLES.SUPPLIER_MANAGEMENT,
    Name: "Supplier Management",
    Actions: [
      PERMISSIONS.SUPPLIER_MANAGEMENT,
      PERMISSIONS.MY_PROFILE,

      moduleActions.PO_MANAGEMENT_EDIT,
    ],
  },
  {
    Rol: ROLES.CUSTOMER_SUPPLIER_MANAGEMENT,
    Name: "Customer Supplier Management",
    Actions: [
      PERMISSIONS.DASHBOARD,
      PERMISSIONS.PO_VISIBILITY,
      PERMISSIONS.PO_MANAGEMENT,
      PERMISSIONS.SUPPLIER_MANAGEMENT,
      PERMISSIONS.TRANSPORT_PLANS,
      PERMISSIONS.SHIPMENTS,
      PERMISSIONS.FINANCE,
      PERMISSIONS.TIME_SENSITIVE,
      PERMISSIONS.ANALYTICS,
      PERMISSIONS.MY_REPORTS,
      PERMISSIONS.LOGISTICS_TOOLS,
      PERMISSIONS.MY_PROFILE,
      PERMISSIONS.LOAD_PO,

      PERMISSIONS.QUICK_SEARCH,

      moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,
      moduleActions.PO_MANAGEMENT_EDIT,
      moduleActions.SHIPMENT_DETALLE,
      moduleActions.PEDIDO_DETALLE,
      moduleActions.SHIPMENT_VIEW_DOCUMENT,
      moduleActions.MI_PERFIL_DOCUMENTS_LIST_COMPANY,
      moduleActions.MI_PERFIL_USER_LIST
    ],
  },
];
